<template>
  <div
    style="
      height: 100vh;
      width: 100vw;
      position: fixed;
      background: var(--clr-black-0);
      z-index: 10;
    "
    class="f-center f-column"
  >
    <div
      v-if="!loading && protectionDelay"
      class="f-center f-column text-center pa-8 anim-show_normal"
    >
      <div class="text-semi-large">
        {{ $t('messages.initial_protection_title') }}
      </div>
      <div class="text-medium mt-1">
        {{ $t('messages.initial_protection_subtitle') }}
      </div>
      <div class="timer text-large my-4 weight_700">
        {{ protectionDelay }}
      </div>
      <div
        class="text-medium clr-grey"
        v-html="$t('messages.initial_protection_note')"
      ></div>
    </div>

    <div
      v-if="errors.length"
      class="weight_500 text-large anim-show_normal px-16 text-center f-column"
    >
      <div v-if="isOnline">
        {{ $t('messages.error_reload') }}
      </div>
      <div v-else>
        {{ $t('messages.error_check_internet_connection') }}
      </div>

      <div
        class="gw_btn-v1 mt-8 mx-auto"
        @click="reloadPage"
      >
        <i class="mdi mdi-refresh text-large mr-2"></i>
        {{ $t('btn.reload') }}
      </div>
      <div class="text-small mt-8">
        <div
          v-for="error in errors"
          :key="error"
        >
          {{ error }}
        </div>
      </div>
    </div>
    <div
      v-if="update"
      class="weight_500 text-large anim-show_normal px-16 text-center"
    >
      <span class="uppercase">
        {{ $t('messages.update_in_progress') }}
      </span>
      <br />
      {{ $t('messages.thx_patience') }}
      <br />
      {{ $t('messages.well_be_back') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  props: {
    loading: Boolean,
    errors: { type: Array, default: () => [] },
    update: Boolean,
    protectionDelay: Number,
  },
  data() {
    return { isOnline: window.navigator.onLine }
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>
